import { render, staticRenderFns } from "./multipleChoiceQuestions.vue?vue&type=template&id=512e1136&scoped=true&"
import script from "./multipleChoiceQuestions.vue?vue&type=script&lang=js&"
export * from "./multipleChoiceQuestions.vue?vue&type=script&lang=js&"
import style0 from "./multipleChoiceQuestions.vue?vue&type=style&index=0&id=512e1136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512e1136",
  null
  
)

export default component.exports